import {RefObject} from "react";

export const useScrollTo = (ref: RefObject<HTMLElement> | undefined | null) => () => {
	const current = ref?.current;

	if (current) {
		scrollTo(current);
	}
};

export const scrollTo = (element: HTMLElement) => {
	window.scrollTo({
		top: element.getBoundingClientRect().top + window.scrollY - 20,
		behavior: "smooth",
	});
};
